export default "__VITE_ASSET__6220b77c__"